import React from 'react'
import { Tooltip } from 'antd'
import { currencyMask } from 'src/components/Formik'

interface Itypes {
  value: number
  code?: string
  precision?: number
}

function getPrecision(value: number, oldPrecision = 2) {
  if (oldPrecision === 2) return 2
  const splited = value.toString().split('.')
  if (!splited[1]) return oldPrecision
  return splited[1].length
}

export function formatCurrency({ value, code = '', precision = 2 }: Itypes) {
  const newPrecision = getPrecision(value, precision)
  const fullValue = currencyMask({
    formatStr: true,
    prefix: `${code} `,
    value,
    precision: newPrecision
  }).maskedValue

  const compactFormat = new Intl.NumberFormat('pt-BR', {
    notation: 'compact',
    compactDisplay: 'short',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
    ...(code
      ? {
          style: 'currency',
          currency: code,
          currencyDisplay: 'code'
        }
      : {
          style: 'decimal'
        })
  }).format(value)
  return <Tooltip title={fullValue}>{compactFormat}</Tooltip>
}
